goog.provide("shadow.js.shim.module$dayjs$plugin$weekday");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$weekday");
shadow.js.shim.module$dayjs$plugin$weekday = shadow.js.nativeProvides["dayjs/plugin/weekday"] = require("dayjs/plugin/weekday");
module$shadow_js_shim_module$dayjs$plugin$weekday.default = shadow.js.shim.module$dayjs$plugin$weekday;
